<app-info-modal title="Cobrança por Terminais Stone">
    <div class="eu-display_block emd-table-responsive pricing-modal-body rounded">
        <table class="emd-table">
            <thead>
                <th>Modelo</th>
                <th>Regra</th>
            </thead>
            <tbody>
                <tr>
                    <td>Aluguel</td>
                    <td class="break-line">
                        Cobrança mensal descontada da agenda de recebíveis. Exemplo: R$ 90 por mês.
                    </td>
                </tr>
                <tr>
                    <td>Adesão</td>
                    <td class="break-line">
                        Cobrança única que o cliente pode parcelar na contratação. Exemplo: R$ 900
                        em até 12 vezes.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</app-info-modal>
